import React from "react";
import "./ReservationCard.css";
const ReservationCard = () => {
  return (
    <div className="">
      <div className="ft-fixed-area">
        <div className="reservation-box">
          <div className="reservation-wrap">
            <h3 className="res-title">Open Hour</h3>
            <div className="res-date-time">
              <div className="res-date-time-item">
                <div className="res-date">
                  <div className="res-date-item">
                    <div className="res-date-text">
                      <p>Tuesday:</p>
                    </div>
                    <div className="res-date-dot">
                      .......................................
                    </div>
                  </div>
                </div>
                <div className="res-time">
                  <div className="res-time-item">
                    <p>7AM - 9PM</p>
                  </div>
                </div>
                <div className="clearfix"></div>
              </div>
              <div className="res-date-time-item">
                <div className="res-date">
                  <div className="res-date-item">
                    <div className="res-date-text">
                      <p>Wednesday:</p>
                    </div>
                    <div className="res-date-dot">
                      .......................................
                    </div>
                  </div>
                </div>
                <div className="res-time">
                  <div className="res-time-item">
                    <p>7AM - 9PM</p>
                  </div>
                </div>
                <div className="clearfix"></div>
              </div>
              <div className="res-date-time-item">
                <div className="res-date">
                  <div className="res-date-item">
                    <div className="res-date-text">
                      <p>Thursday:</p>
                    </div>
                    <div className="res-date-dot">
                      .......................................
                    </div>
                  </div>
                </div>
                <div className="res-time">
                  <div className="res-time-item">
                    <p>7AM - 9PM</p>
                  </div>
                </div>
                <div className="clearfix"></div>
              </div>
              <div className="res-date-time-item">
                <div className="res-date">
                  <div className="res-date-item">
                    <div className="res-date-text">
                      <p>Friday:</p>
                    </div>
                    <div className="res-date-dot">
                      .......................................
                    </div>
                  </div>
                </div>
                <div className="res-time">
                  <div className="res-time-item">
                    <p>7AM - 9PM</p>
                  </div>
                </div>
                <div className="clearfix"></div>
              </div>
              <div className="res-date-time-item">
                <div className="res-date">
                  <div className="res-date-item">
                    <div className="res-date-text">
                      <p>Saturday:</p>
                    </div>
                    <div className="res-date-dot">
                      .......................................
                    </div>
                  </div>
                </div>
                <div className="res-time">
                  <div className="res-time-item">
                    <p>7AM - 9PM</p>
                  </div>
                </div>
                <div className="clearfix"></div>
              </div>
              <div className="res-date-time-item">
                <div className="res-date">
                  <div className="res-date-item">
                    <div className="res-date-text">
                      <p>Sunday:</p>
                    </div>
                    <div className="res-date-dot">
                      .......................................
                    </div>
                  </div>
                </div>
                <div className="res-time">
                  <div className="res-time-item">
                    <p>7AM - 9PM</p>
                  </div>
                </div>
                <div className="clearfix"></div>
              </div>
              <div className="res-date-time-item">
                <div className="res-date">
                  <div className="res-date-item">
                    <div className="res-date-text">
                      <p>Monday:</p>
                    </div>
                    <div className="res-date-dot">
                      .......................................
                    </div>
                  </div>
                </div>
                <div className="res-time">
                  <div className="res-time-item">
                    <p>Close</p>
                  </div>
                </div>
                <div className="clearfix"></div>
              </div>
            </div>
            <h3 className="res-title">Reservation Numbers</h3>
            <p className="res-number">(617)-276-8031</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReservationCard;
